function inPageAlertPosition() {
    const alertEl = document.querySelector('.content-page-main .in-page-alert');
    const alertPlaceholderEl = document.querySelector('.content-page-main .in-page-alert-placeholder');

   if (!alertPlaceholderEl) {
    return;
   }

   if (alertEl) {
    alertPlaceholderEl.appendChild(alertEl);
    alertEl.classList.add('ready');
   }else  {
    alertPlaceholderEl.remove();
   }
}

window.addEventListener('load', () => {
    inPageAlertPosition();
})